<section class="webinarTopBanner">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="topBannerWrapper">
            <div class="top-banner-left">
              <h1>Improving Research Manuscripts Using <span>AI-Powered</span> Insights: </h1>
              <p>Enago Reports for Effective Research Communication</p>
              <!-- <div class="btn-group">
                <button (click)="scrollToElementWithOffset('registerForm', 130)" class="filled-btn">Register Now</button>
              </div>
              <span class="timings">
                <b>Wednesday, May 08, 2024</b> | 9:00 - 10:00 AM ET
              </span> -->
            </div>
            <div class="top-banner-right">
              <div class="speaker-img">
                <img src="../../../../assets/images/webinar/kk.png" alt="speaker KK" class="img-fluid" />
              </div>
              <div class="speaker-img">
                <img src="../../../../assets/images/webinar/piyush.png" alt="speaker piyush" class="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</section>

  <section class="goBack">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <a [routerLink]="['/webinars']"><i class="fa fa-long-arrow-left"></i>All Webinars</a>
            </div>
        </div>
    </div>
  </section>
  
  <section class="section-pd">
    <div class="trinka_container">
      <div class="row">
        <div class="col-md-7 col-lg-7">
            <div class="dots">
              <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
              <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
            </div>
            <div class="trinka-title">
              <p>Academic writing revolves around effectively conveying complex ideas with precision and nuance while maintaining readability, accessibility, and inclusivity. Regardless of the eventual goal — publishing research papers, writing theses, or engaging in scholarly discourse — conveying ideas and advancing knowledge with precision, clarity, and inclusivity is essential. In this webinar, we explore <a href="https://www.reports.enago.com/reports/language-quality-report" target="_blank" rel="noopener noreferrer" class="text-link">language quality</a> evaluation and enhancement using AI-powered reports.</p>
            </div>
            <div class="trinka-title mb-0">
              <h2>The session focuses on the following topics:</h2>
              <ul class="bullets-pt">
                <li>Importance of Language Quality in Academic Communication </li>
                <li>Common Challenges in Maintaining Language Quality</li>
                <li>AI in Language Quality Evaluation</li>
                <li>Live Demonstration of Enago Reports: Language quality report</li>
                <li>Understanding the Language Quality Score and Actionable Suggestions</li>
              </ul>
            </div>
        </div>
        <div class="col-md-5 col-lg-4 offset-lg-1">
            <div class="webinar-video">
                <div class="webinar-img">
                    <button type="button" data-toggle="modal" data-target="#webinarVideo4">
                        <img src="/assets/images/webinar/webinar-3.png" class="img-fluid" loading="lazy" alt="trinka webinars" />
                        <span></span>
                    </button>
                </div>
                <!-- <app-upcoming-event></app-upcoming-event> -->
                <div class="partner-with-us">
                    <h5>Partner with us!</h5>
                    <p>Co-host a FREE AI webinar at your university.</p>
                    <div class="btn-group">
                        <a [routerLink]="['/webinars']" fragment="getInTouch" class="filled-btn w-100">Get in Touch</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </section>
  
  <section class="section-pd abt-session">
    <div class="trinka_container">
      <div class="row">
        <div class="col-12">
          <div class="session-wrapper">
            <div class="session-titles">
              <div class="dots">
                <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
                <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
              </div>
              <div class="trinka-title mb-0">
                <h2 class="text-white">Who Should Attend This Session?</h2>
              </div>
            </div>
            <div class="session-body">
              <ul class="bullets-pt">
                <li>Graduate students</li>
                <li>Early-stage researchers</li>
                <li>Doctoral & postdoctoral students</li>
                <li>Established researchers and academicians</li>
                <li>Editors</li>
                <li>Peer Reviewers</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <section class="section-pd speaker-section">
    <div class="trinka_container">
      <div class="row">
        <div class="col-12">
          <div class="dots">
            <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
            <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
          </div>
          <div class="trinka-title mb-40">
            <h2>Speakers' Profiles</h2>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-lg-4 col-md-4">
          <div class="speaker-box">
            <div class="img">
              <img src="../../../../assets/images/webinar/kk-tumbnail.png" alt="kk" loading="lazy" />
            </div>
            <h4>Dr. Krishna Kumar Venkitachalam</h4>
            <p>Innovation Officer at <br/>Trinka AI</p>
          </div>
        </div>
        <div class="col-lg-8 col-md-8">
          <p>Dr. KK is an orthopedic surgeon by qualification with 15+ years of experience in academic publishing under various roles, including manuscript editing, manuscript writing, editor training, author education, language technology solutions, and innovation. As an editor/writer, he has helped hundreds of authors/researchers publish their research in leading journals worldwide. Being passionate about science communication and teaching, he has conducted several interactive training programs and author workshops. These included touring workshops in India and internationally along with online workshops in collaboration with universities and publishers. With his background in academia, experience in science communication experience, and affinity towards technological solutions, he plays a role as a consultant in the integration of new technologies to publishing platforms and for designing customized publication solutions for institutions and publishers.</p>
        </div>
        <div class="col-12">
          <hr />
        </div>
        <div class="col-lg-4 col-md-4">
          <div class="speaker-box">
            <div class="img">
              <img src="../../../../assets/images/webinar/piyush-tumbnail.png" alt="piyush" loading="lazy" />
            </div>
            <h4>Piyush Agarwal</h4>
            <p>Lead Product Manager at<br/>Trinka AI</p>
          </div>
        </div>
        <div class="col-lg-8 col-md-8">
          <p>Piyush has 12 years of experience in designing and building cutting-edge digital products in the education, technology, and academic publishing industries. Over the period of last decade, as a product manager, he has worked with large corporates, SMEs, start-ups, and start-up accelerator, adding immense value to their businesses. As a developer turned product manager, he uniquely stands at the intersection of business and technology with experience in both the Corporate and start-up world. Piyush is Lead Product Manager at Crimson and heads the product and design teams of Trinka.ai and Enago Read. Piyush is focused on leveraging the power of AI to solve the researchers’ problems and build a resilient tech ecosystem for the entire academic publishing industry.</p>
        </div>
      </div>
    </div>
  </section>
  
  
  <div class="modal fade" id="webinarVideo4" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close" (click)="stopAllVideos()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" width="100%" height="642" src="https://www.youtube.com/embed/7qxDl7LGBfI?si=_OE-LHeG-5YLzixW"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>